module.exports = __webpack_public_path__ + "media/images/yellow_star_half-813dd3ee7575a4f2b3d457eb330f4ba5.svg";